import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobangloretaxiservice() {



const cardData = {
  keyword: "Pune to Bangalore Taxi Service",
  heading: "Lotus Cab: Pune to Bangalore Taxi Service",

  headingDescription:
    "Lotus Cab offers reliable and comfortable Pune to Bangalore Taxi Service for long-distance interstate travel. Whether you are relocating, planning a corporate visit, family trip, or personal journey, our well-maintained sedan and SUV fleet ensures a safe and smooth ride. Our professional chauffeurs are experienced in highway and interstate routes, ensuring punctuality and safety throughout the journey. We provide transparent per-km pricing with one-way and round-trip flexibility. With 24/7 booking assistance and doorstep pickup anywhere in Pune, we make your Pune to Bangalore cab travel convenient, affordable, and stress-free.",

  top: "Top Places to Visit in Bangalore with Lotus Cab",

  topPlaces: [
    {
      title: "Lalbagh Botanical Garden",
      description:
        "Lalbagh Botanical Garden is one of the most famous attractions in Bangalore. Known for its glass house and rare plant species, it attracts nature lovers and photographers. The garden spreads across vast greenery and offers peaceful walking trails. Flower shows are major highlights during festive seasons. Ideal for families and tourists seeking relaxation. A must-visit during your Bangalore trip."
    },
    {
      title: "Bangalore Palace",
      description:
        "Bangalore Palace showcases royal architecture inspired by Tudor-style designs. The palace features wooden carvings and beautiful interiors. It reflects the rich heritage of Karnataka’s royal history. Popular among tourists and history enthusiasts. Photography and guided tours are available. A cultural landmark worth visiting."
    },
    {
      title: "Cubbon Park",
      description:
        "Cubbon Park is a green oasis in the heart of Bangalore city. It offers peaceful surroundings and walking paths. Ideal for morning walks and family outings. Surrounded by historic buildings and museums. Popular among locals and visitors alike. Perfect relaxation spot after a long journey."
    },
    {
      title: "Wonderla Amusement Park",
      description:
        "Wonderla is one of India’s top amusement parks. It features thrilling rides and water attractions. Ideal for family and group entertainment. Clean and well-maintained facilities available. Popular among tourists from Pune. Perfect for fun-filled day trips."
    },
    {
      title: "ISKCON Temple Bangalore",
      description:
        "ISKCON Temple is a spiritual landmark in Bangalore. Dedicated to Lord Krishna, it attracts devotees nationwide. The temple architecture is grand and peaceful. Ideal for spiritual seekers and families. Evening aarti creates divine atmosphere. A serene place to visit."
    },
    {
      title: "Bannerghatta National Park",
      description:
        "Bannerghatta National Park offers wildlife safari experiences. Visitors can see lions, tigers, and elephants. Ideal for adventure and nature lovers. Safe and guided tours available. Popular among families. Adds excitement to your Bangalore travel."
    },
    {
      title: "Commercial Street",
      description:
        "Commercial Street is a famous shopping destination in Bangalore. Known for fashion stores and local markets. Ideal for shopping enthusiasts. Offers wide range of products. Popular among tourists. A vibrant city experience."
    },
    {
      title: "Nandi Hills",
      description:
        "Nandi Hills is a scenic hill station near Bangalore. Known for sunrise views and cool weather. Ideal for weekend relaxation. Popular among photographers and bikers. Peaceful escape from city life. Perfect addition to your Bangalore trip."
    }
  ],

  services: [
    {
      name: "Pune to Bengaluru Taxi Service",
      description:
        "Reliable interstate taxi service from Pune to Bengaluru with experienced drivers. Comfortable sedan and SUV options available. Transparent per-km pricing maintained. Suitable for relocation and business travel. Safe and smooth highway journey ensured. 24/7 booking support available."
    },
    {
      name: "Pune to Bangalore One Way Taxi",
      description:
        "Affordable one-way taxi service from Pune to Bangalore. Pay only for single-side distance with clear billing. Ideal for drop and relocation travel. Professional chauffeur ensures safe journey. Flexible pickup scheduling available. Comfortable long-distance ride guaranteed."
    },
    {
      name: "Pune to Bangalore Round Trip Cab",
      description:
        "Flexible round-trip cab service for Pune to Bangalore travel. Suitable for business meetings and family visits. Transparent pricing with return scheduling options. Spacious and well-maintained vehicles provided. Experienced highway drivers ensure safety. Convenient and stress-free travel."
    },
    {
      name: "Pune to Bangalore Outstation Taxi",
      description:
        "Outstation taxi service with professional drivers and sanitized vehicles. Long-distance comfort ensured. Clear pricing structure followed. Suitable for personal and corporate travel. Timely pickup from Pune locations. Reliable service guaranteed."
    },
    {
      name: "Affordable Pune to Bangalore Cab",
      description:
        "Budget-friendly Pune to Bangalore cab without compromising quality. Competitive per-km rates available. Clean and comfortable vehicles provided. Ideal for families and individuals. Transparent billing maintained. Dependable interstate travel solution."
    },
    {
      name: "Luxury Cab Pune to Bangalore",
      description:
        "Premium luxury cab service for executive and VIP travel. High-end vehicles available. Superior comfort and spacious interiors ensured. Professional and courteous chauffeurs provided. Ideal for corporate and special occasions. Premium travel experience guaranteed."
    },
    {
      name: "SUV Taxi Pune to Bangalore",
      description:
        "Spacious SUV taxis for group and family travel. Extra luggage capacity included. Comfortable seating for long-distance ride. Ideal for corporate teams. Smooth highway performance ensured. Safe interstate journey guaranteed."
    },
    {
      name: "Online Cab Booking Pune to Bangalore",
      description:
        "Easy online booking with instant confirmation. Secure payment options available. Flexible pickup and drop scheduling supported. Transparent fare breakdown provided. 24/7 customer assistance available. Hassle-free travel planning ensured."
    }
  ],

  tableData: [
    ["Pune to Bengaluru Taxi Service", "Pune to Bangalore Cab"],
    ["Pune to Bangalore One Way Taxi", "Pune to Bangalore Round Trip Cab"],
    ["Pune to Bangalore Outstation Taxi", "Affordable Pune to Bangalore Cab"],
    ["Luxury Cab Pune to Bangalore", "SUV Taxi Pune to Bangalore"],
    ["Cheap Pune to Bangalore Taxi", "Online Cab Booking Pune to Bangalore"],
    ["Best Cab Service Pune to Bangalore", "Corporate Taxi Pune to Bangalore"],
    ["Family Trip Cab Pune to Bangalore", ""]
  ],

  whychoose: [
    {
      WhyChooseheading: "Reliable Interstate Travel",
      WhyChoosedescription:
        "Lotus Cab ensures safe and dependable interstate travel from Pune to Bangalore with experienced drivers and well-maintained vehicles."
    },
    {
      WhyChooseheading: "Transparent Per KM Pricing",
      WhyChoosedescription:
        "Clear per-km fare structure with no hidden charges and complete billing transparency."
    },
    {
      WhyChooseheading: "One-Way & Round Trip Flexibility",
      WhyChoosedescription:
        "Choose one-way drop or round-trip service according to your travel plan."
    },
    {
      WhyChooseheading: "Experienced Highway Drivers",
      WhyChoosedescription:
        "Professional drivers skilled in long-distance interstate travel routes."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription:
        "Regularly serviced and sanitized sedan and SUV vehicles for safe travel."
    },
    {
      WhyChooseheading: "24/7 Booking Support",
      WhyChoosedescription:
        "Round-the-clock customer support for booking and trip coordination."
    },
    {
      WhyChooseheading: "Corporate Travel Friendly",
      WhyChoosedescription:
        "Ideal for business meetings and executive travel needs."
    },
    {
      WhyChooseheading: "Family & Group Comfort",
      WhyChoosedescription:
        "Spacious vehicle options for comfortable family travel."
    }
  ]
};

const faqData = [
  { question: "How long does Pune to Bangalore taxi take?", answer: "The journey typically takes around 14 to 16 hours depending on traffic and stops." },
  { question: "Is one-way service available?", answer: "Yes, one-way taxi service is available with transparent pricing." },
  { question: "Are toll charges included?", answer: "Toll charges are usually billed separately and clearly informed before booking." },
  { question: "Do you provide SUV options?", answer: "Yes, SUV taxis are available for family and group travel." },
  { question: "Is night travel possible?", answer: "Yes, 24/7 taxi service including night travel is available." },
  { question: "Do you offer round-trip booking?", answer: "Yes, flexible round-trip service is available." },
  { question: "Are drivers experienced in interstate travel?", answer: "Yes, our drivers are skilled and experienced in interstate routes." },
  { question: "Can I book online?", answer: "Yes, easy online booking with instant confirmation is available." },
  { question: "Are vehicles sanitized?", answer: "Yes, vehicles are cleaned and sanitized before every trip." },
  { question: "Do you offer corporate taxi service?", answer: "Yes, corporate travel service is available for business trips." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kiran Rao",
    feedback:
      "Booked Pune to Bangalore taxi for relocation. The journey was comfortable and safe. Transparent pricing and professional driver made it smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Patil",
    feedback:
      "Our family trip to Bangalore was excellent. Spacious SUV and experienced driver ensured stress-free travel.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Rajeev Sharma",
    feedback:
      "Corporate trip from Pune to Bangalore was handled professionally. On-time pickup and fair pricing impressed me.",
    rating: 5
  }
];




























































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bangalore Taxi Service",
  "image": "https://lotuscab.com/assets/images/pune-to-bangalore-taxi-service.jpg", 
  "description": "Lotus Cab provides Pune to Bangalore taxi services with one way, round trip, luxury, and SUV options. Book affordable and reliable cabs for corporate, family, and outstation trips, ensuring comfortable and safe long-distance travel with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-bangalore-taxi-service"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune to Bangalore Taxi Service | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Bangalore taxi service with Lotus Cab. Affordable one way & round trip cabs including SUV & luxury options for corporate & family trips. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Bengaluru Taxi Service, Pune to Bangalore Cab, Pune to Bangalore One Way Taxi, Pune to Bangalore Round Trip Cab, Pune to Bangalore Outstation Taxi, Affordable Pune to Bangalore Cab, Luxury Cab Pune to Bangalore, SUV Taxi Pune to Bangalore, Cheap Pune to Bangalore Taxi, Online Cab Booking Pune to Bangalore, Best Cab Service Pune to Bangalore, Corporate Taxi Pune to Bangalore, Family Trip Cab Pune to Bangalore" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/25.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobangloretaxiservice;